
import { supabase } from '../../client';
import { BookingDeletionResult } from './types';

// Delete a booking (admin function) with group booking consideration
export const deleteBooking = async (
  bookingId: string,
  classId: string
): Promise<BookingDeletionResult> => {
  try {
    // First check if the booking exists
    const { data: booking, error: bookingError } = await supabase
      .from('bookings')
      .select('*')
      .eq('id', bookingId)
      .single();
    
    if (bookingError) {
      console.error('Error finding booking:', bookingError);
      return { success: false, error: 'Booking not found' };
    }
    
    // Get the group size (default to 1 if not set)
    const groupSize = booking.group_size || 1;
    
    // Get the class data to update available spots
    const { data: classData, error: classError } = await supabase
      .from('classes')
      .select('availablespots')
      .eq('id', classId)
      .single();
    
    if (classError) {
      console.error('Error finding class:', classError);
      return { success: false, error: 'Class not found' };
    }
    
    // Delete the booking
    const { error: deleteError } = await supabase
      .from('bookings')
      .delete()
      .eq('id', bookingId);
    
    if (deleteError) {
      console.error('Error deleting booking:', deleteError);
      return { success: false, error: `Failed to delete booking: ${deleteError.message}` };
    }
    
    // Increase available spots for the class by the group size
    const { error: updateError } = await supabase
      .from('classes')
      .update({ 
        availablespots: (classData.availablespots || 0) + groupSize 
      })
      .eq('id', classId);
    
    if (updateError) {
      console.error('Error updating class availability:', updateError);
      // The booking is already deleted, so we'll consider this a partial success
      return { 
        success: true,
        error: 'Booking deleted, but class availability could not be updated' 
      };
    }
    
    return { success: true };
  } catch (error: any) {
    console.error('Error deleting booking:', error);
    return { 
      success: false, 
      error: error.message || 'An unexpected error occurred while deleting the booking' 
    };
  }
};
